export const getFullScreenImageSources = () => {
  return [
    // Mobile devices
    {
      width: 390,
      height: 844,
      media: 390,
    },
    {
      width: 430,
      height: 932,
      media: 430,
    },
    // Tablet devices
    {
      width: 768,
      height: 1024,
      media: 768,
    },
    // Desktop devices
    {
      width: 960,
      height: 540,
      media: 960,
    },
    {
      width: 1024,
      height: 768,
      media: 1024,
    },
    {
      width: 1280,
      height: 800,
      media: 1280,
    },
    {
      width: 1366,
      height: 768,
      media: 1366,
    },
    {
      width: 1920,
      height: 1080,
      media: 1920,
    },
    {
      width: 2560,
      height: 1440,
      media: 2560,
    },
  ];
};

const mapBreakpointsToSources = (height, bpEntries) => {
  return bpEntries.map(screenSize => ({
    width: screenSize.width,
    height,
    media: screenSize.media,
  }));
};

export const getFullWidthImageSourcesMobile = (height, cutoff) => {
  const bpEntries = getFullScreenImageSources().filter(
    screenSize => screenSize.media !== 0 && screenSize.media <= cutoff
  );

  return mapBreakpointsToSources(height, bpEntries);
};

export const getFullWidthImageSourcesDesktop = (
  height,
  minCutoff,
  maxCutoff
) => {
  const bpEntries = getFullScreenImageSources().filter(
    screenSize =>
      screenSize.media !== 0 &&
      screenSize.media > minCutoff &&
      (typeof maxCutoff !== 'undefined' ? screenSize.media <= maxCutoff : true)
  );

  return mapBreakpointsToSources(height, bpEntries);
};
